const MP_QR_ERROR_MESSAGES: Record<string, string> = {
  mp_pos_not_configured: 'Este local no tiene caja QR de Mercado Pago. Configurala en Integraciones → Mercado Pago.',
  mp_order_create_failed: 'Mercado Pago no pudo crear el QR. Revisá que la caja esté vinculada y con monto cerrado.',
  pos_not_found: 'Mercado Pago no pudo crear el QR. Revisá que la caja esté vinculada y con monto cerrado.',
  plan_mp_qr: 'Mercado Pago QR entra en Crece.',
  mp_qr_regenerate_limit: 'Ya no se puede generar otro QR para esta venta.',
};

const MP_QR_MIN_AMOUNT_MESSAGE = 'Mercado Pago QR pide $15 como mínimo.';

/**
 * MP devuelve el mínimo como texto libre ('…greater than or equal to 15.00').
 * '15.00' solo cuenta con contexto de monto/mínimo — cualquier otro error que
 * mencione el literal (un total, un id) no debe recibir el copy de mínimo.
 */
function isMpQrMinAmountMessage(m: string): boolean {
  if (m.includes('greater than or equal to 15')) return true;
  return m.includes('15.00') && (m.includes('amount') || m.includes('minimum') || m.includes('monto'));
}

const MP_QR_TRANSPORT_PATTERNS = ['failed to send a request', 'network request failed', 'fetch failed', 'cors', 'edge function', 'non-2xx'];

export function mpQrGenerateErrorMessage(message: string): string {
  const m = message.toLowerCase();
  for (const [key, msg] of Object.entries(MP_QR_ERROR_MESSAGES)) {
    if (m.includes(key)) return msg;
  }
  if (isMpQrMinAmountMessage(m)) return MP_QR_MIN_AMOUNT_MESSAGE;
  if (!m.includes('mp_pos_not_configured') && !m.includes('plan_mp_qr') && MP_QR_TRANSPORT_PATTERNS.some((p) => m.includes(p))) {
    return 'No se pudo generar el QR. Revisá la conexión.';
  }
  return message || 'No se pudo generar el QR en Mercado Pago.';
}
